import React, {Fragment} from 'react';

import {ArrayUtils} from "../../../Utils";
import {StreamBankLink} from "../StreamBankLink";

export function ContextNodesTableColumn(props) {
    const {Value} = props;

    if (!Value) {
        return <span>N/A</span>;
    }

    let contextNodes = (Value ?? [])
        // .map((x) => x?.ContextNodeDetails ?? x?.ContextNode)
        .filter(x => x?.contextNodeId);

    // remove duplicates
    contextNodes = ArrayUtils.uniqueByKey(contextNodes, 'contextNodeId')

    const contextNodesLinks = contextNodes
        .map((contextNode, index) =>
            <Fragment key={contextNode.contextNodeId}>
                <StreamBankLink Context={contextNode.link}>{contextNode.title ?? contextNode.shortName}</StreamBankLink>
                {index < contextNodes.length - 1 ? <br/> : null}
            </Fragment>
        );

    return contextNodesLinks;
}
